import { getAuth, signOut } from 'firebase/auth'
import { useDispatch } from 'react-redux'
import { Logger } from '@/components/Logger'
import { publicConfig } from '@/config/publicConfig'
import { LocalStorageKeys } from '@/constants/localstorage'
import { queryClient } from '@/services/api'
import { plexWebSocketClient } from '@/services/api/plex/PlexWebSocketClient'
import { clearNotifications } from '@/store/notificationSlice'
import { clearAffiliateSignup } from '@/utils/affiliateSignup'
import { setApiKey } from '@/utils/apiKeyAuth'
import { setCurrentUserScope } from '@/utils/userScopedStorage'

const useSignOutAndClearStore = () => {
  const dispatch = useDispatch()

  const signOutAndClearStore = async () => {
    const auth = getAuth()
    auth.tenantId = publicConfig.firebase.tenantId

    Logger.log('DEBUG signOutAndClearStore: Starting sign out and clear store')

    Logger.log('DEBUG signOutAndClearStore: Closing the multiplex WebSocket connection...')
    plexWebSocketClient.shutdown()

    // Clear tab auth storage without wiping unrelated app preferences.
    const hadApiKey = Boolean(
      window.sessionStorage.getItem(LocalStorageKeys.API_KEY) ||
        window.localStorage.getItem(LocalStorageKeys.API_KEY),
    )
    Logger.log('DEBUG signOutAndClearStore: Clearing auth storage', { hadApiKey })
    await queryClient.cancelQueries({ queryKey: ['affiliates'] })
    queryClient.removeQueries({ queryKey: ['affiliates'] })
    clearAffiliateSignup()
    setApiKey(null)
    setCurrentUserScope(null)
    window.sessionStorage.removeItem(LocalStorageKeys.FIREBASE_TOKEN)
    window.localStorage.removeItem(LocalStorageKeys.FIREBASE_TOKEN)
    window.sessionStorage.removeItem(LocalStorageKeys.SENTRY_USER)
    window.localStorage.removeItem(LocalStorageKeys.SENTRY_USER)
    window.localStorage.removeItem(LocalStorageKeys.API_KEY)
    window.localStorage.removeItem(LocalStorageKeys.BONDTRADER_PROMO_BANNER_DISMISSED)
    await signOut(auth)

    Logger.log('DEBUG signOutAndClearStore: All WebSocket connections closed during logout')

    // Clear Redux store data
    dispatch(clearNotifications())
  }

  return signOutAndClearStore
}

export default useSignOutAndClearStore
